import React from 'react';
import { useForm, ValidationError } from '@formspree/react';
import { faEnvelope, faMapMarker, faPaperPlane, faPhone } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Col, Container, Row, Button } from 'react-bootstrap';
import { faGithub, faLinkedin } from '@fortawesome/free-brands-svg-icons';

const Contact = () => {
    const [state, handleSubmit] = useForm("xyyogpad");

    return (
        <div id='contact' className="text-white  py-3">
            <Container >
                <h1 className="text-start">Contact <span style={{ color: 'red' }}>Me</span></h1>
                <hr className="w-25" />

                <Row className="g-3">
                    <Col md={4} className='d-flex align-items-center justify-content-center'>
                        <div>
                            <div className="text-start">
                                <p><FontAwesomeIcon icon={faMapMarker} />  59,GM Bari North Badda. Dhaka-1212</p>
                                <p><FontAwesomeIcon icon={faPhone} /> <a style={{ textDecoration: 'none' }} href="tel:+8801646190607 ">+8801646190607</a> </p>
                                <p><FontAwesomeIcon icon={faEnvelope} /> zahidhasan2806@gmail.com</p>
                            </div>
                            <div className="text-start">
                                <Button className="me-3" variant="dark" href="https://github.com/zahidhasan2806" target="blank"><FontAwesomeIcon icon={faGithub} /> GitHub</Button>
                                <Button href="https://www.linkedin.com/in/zahidhasan2806/" variant="info" target="blank" ><FontAwesomeIcon icon={faLinkedin} /> LinkedIn</Button>
                            </div>
                        </div>
                    </Col>
                    <Col md={8}>
                        <div>
                            <form onSubmit={handleSubmit} className="p-5 text-center border rounded">
                                <p>Want to work together or have any questions?</p>
                                <input
                                    id="name"
                                    type="text"
                                    name="name"
                                    className="m-1  px-4 py-2 w-100"
                                    placeholder='Your Name'
                                />
                                <ValidationError
                                    prefix="Name"
                                    field="Name"
                                    errors={state.errors}
                                /> <br />
                                <input
                                    id="email"
                                    type="email"
                                    name="email"
                                    className="m-1  px-4 py-2 w-100"
                                    placeholder="Your Email"
                                />
                                <ValidationError
                                    prefix="Email"
                                    field="email"
                                    errors={state.errors}
                                /><br />
                                <input
                                    id="subject"
                                    type="subject"
                                    name="subject"
                                    className="m-1  px-4 py-2 w-100"
                                    placeholder="Subject"
                                />
                                <ValidationError
                                    prefix="Subject"
                                    field="subject"
                                    errors={state.errors}
                                /><br />
                                <textarea
                                    id="message"
                                    name="message"
                                    className="m-1  px-4 py-2  w-100"
                                    placeholder="Write your message here"
                                />
                                <ValidationError
                                    prefix="Message"
                                    field="message"
                                    errors={state.errors}
                                /><br />
                                <Button type="submit" className="rounded-pill px-3" style={{ backgroundColor: "#341f97" }}>
                                    <FontAwesomeIcon icon={faPaperPlane} />  Send
                                </Button>
                            </form>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div >
    );
};

export default Contact;